export default function EditorialEmptyState() {
  return (
    <div data-testid="insights-empty-state" className="border border-[#C5A059]/25 bg-[#F5F2EB] px-8 py-20 text-center">
      <p className="text-sm font-bold uppercase tracking-[0.28em] text-[#C5A059]">Editorial Desk</p>
      <h2 className="mx-auto mt-6 max-w-2xl font-serif text-3xl font-normal leading-tight text-[#1C1613] sm:text-5xl">Official UGI perspectives will appear here.</h2>
      <p className="mx-auto mt-6 max-w-xl text-base font-light leading-8 text-[#524842]">
        Insights is ready for UGI's editorial team. Published articles will be listed here when official content is supplied.
      </p>
    </div>
  );
}
